// extracted by mini-css-extract-plugin
export default {"link":"NavbarDrop_link__0EJy1","linksWrapper":"NavbarDrop_linksWrapper__+vuJd"};